enum DedicationType {
  IN_MEMORY = 'in_memory',
  IN_HONOR = 'in_honor',
}

export default DedicationType;
